import { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectCurrentPromise,
  selectIsLoading,
} from "redux-toolkit/promises/selectors";
import {
  getPromiseByIdAsync,
  createPromiseAsync,
  updatePromiseAsync,
  deletePromiseAsync,
} from "redux-toolkit/promises/actions";

const usePromise = ({ id }) => {
  const dispatch = useDispatch();
  const current = useSelector(selectCurrentPromise);
  const isLoading = useSelector(selectIsLoading);

  useEffect(() => {
    id && dispatch(getPromiseByIdAsync(id));
  }, [dispatch, id]);

  const createPromise = useCallback(
    (newPromise) => {
      dispatch(createPromiseAsync(newPromise));
    },
    [dispatch],
  );

  const updatePromise = useCallback(
    (id, data) => {
      dispatch(updatePromiseAsync({ id, data }));
    },
    [dispatch],
  );

  const deletePromise = useCallback(() => {
    dispatch(deletePromiseAsync(id));
  }, [id, dispatch]);

  return {
    current,
    isLoading,
    createPromise,
    updatePromise,
    deletePromise,
  };
};

export default usePromise;
